import type { ReactNode } from "react";
import { pageFrameClassName, pageHeroClassName, pageShellClassName } from "../lib/pageLayout";

type PageLayoutProps = {
  children: ReactNode;
  className?: string;
  fullBleed?: boolean;
  ariaLabelledBy?: string;
};

/** Use this frame for every route so page width, gutters, and full-bleed behavior stay consistent. */
export function PageLayout({ children, className, fullBleed = false, ariaLabelledBy }: PageLayoutProps) {
  return (
    <main className={fullBleed ? pageFrameClassName(className, "page-layout--full-bleed") : pageShellClassName(className)} {...(ariaLabelledBy ? { "aria-labelledby": ariaLabelledBy } : {})}>
      {children}
    </main>
  );
}

type PageHeroProps = {
  children: ReactNode;
  className?: string;
  as?: "header" | "section" | "div";
};

/** Use this primitive for route-level hero content so hero spacing follows one contract. */
export function PageHero({ children, className, as = "section" }: PageHeroProps) {
  const Tag = as;
  return <Tag className={pageHeroClassName(className)}>{children}</Tag>;
}
